<ep-sub-panel [form]="form" panelType="transparent">
  <form [formGroup]="form">
    <h4 style="font-size: 16px"><b>Document Information</b></h4>

    <!--<div>
                <ep-edit-status class="pull-right" controlPath="Edit_Status" [allowDelete]="false" [allowRestore]="false" [allowClone]="false" ></ep-edit-status>
          </div>-->
    <ep-field columnSpan="3" label="" format="container-text" collapseLabelArea="true">
      <aurora-badge
        *ngIf="getControlValue('Document.Filed_Ind') == 'Y'"
        type="text"
        prominence="low"
        color="info"
        style="font-size: 12px; margin-right: 4px"
      >
        Filed
      </aurora-badge>
      <aurora-badge
        *ngIf="getControlValue('Document.Filed_Ind') == 'N'"
        type="text"
        prominence="low"
        color="warning"
        style="font-size: 12px; margin-right: 4px"
      >
        Unfiled
      </aurora-badge>
      <aurora-badge
        *ngIf="getControlValue('Document.Protected_Ind') == 'Y'"
        type="text"
        prominence="low"
        color="error"
        style="font-size: 12px; margin-right: 4px"
      >
        Protected
      </aurora-badge>
      <aurora-badge
        *ngIf="getControlValue('Document.Sent_Ind') == 'Y'"
        type="text"
        prominence="low"
        color="info"
        style="font-size: 12px; margin-right: 4px"
      >
        Sent
      </aurora-badge>
    </ep-field>
    <ep-field-block>
      <ep-field-section>
        <ep-field columnSpan="4" label="Name" format="text-120" controlPath="Document.Doc_Name"></ep-field>
        <ep-field
          columnSpan="2"
          label="Class"
          format="dropdownSelector-DocClass"
          controlPath="Document.Doc_Class"
          (dataSelected)="docClassSelected($event)"
        ></ep-field>
      </ep-field-section>

      <ep-field-section>
        <ep-field
          columnSpan="6"
          label="Description"
          format="textbox-4099"
          [options]="{ rows: 3 }"
          controlPath="Document.Doc_Desc"
        ></ep-field>
      </ep-field-section>
      <div style="margin-left: 4px">
        Created by {{ getControlValue('Document.Created_By.Entity_Name') }} on
        {{ getControlValue('Document.Created_By.Date') | epDate : 'mm/dd/yy' }}
      </div>
    </ep-field-block>

    <hr />
    <h4 style="font-size: 16px">
      <b>New Filing Reference Info</b>
      <aurora-button type="button" style="float: right" (click)="openAdvancedSearch()" variant="tertiary">Advanced Search</aurora-button>
    </h4>

    <ep-field
      columnSpan="2"
      label="Contract"
      format="search-contract"
      controlPath="NewFiling.Contract.Contract_ID"
      descControlPath="NewFiling.Contract.Contract_Num"
      [options]="{ autoSearch: false, allowClear: true }"
      [criteria]="{
        Contract_Set_Status: 'Inforce;SubOpen;PendingEff;SubReject;Expired;Cancelled',
        Range: 'All',
        Contract_Num_Mode: 'BeginsWith',
        json: 'CT2'
      }"
      (dataSelected)="contractSearchResult($event)"
      (dataCleared)="contractSearchCleared()"
    >
    </ep-field>
    <ep-field
      columnSpan="2"
      label="Claim"
      format="search-claim"
      controlPath="NewFiling.Claim.Claim_ID"
      descControlPath="NewFiling.Claim.Book_Claim_Num"
      [options]="{ autoSearch: false, allowClear: true }"
      [criteria]="{
        Contract_Set_Status: 'Inforce;SubOpen;PendingEff;SubReject;Expired;Cancelled',
        Range: 'All'
      }"
      (dataSelected)="claimSearchResult($event)"
      (dataCleared)="claimSearchCleared()"
    >
    </ep-field>

    <hr />
    <h4 style="font-size: 16px"><b>Add Filing To</b></h4>
    <ep-field
      columnSpan="2"
      label="Entity"
      format="search-entity"
      controlPath="NewFiling.Entity.Entity_ID"
      descControlPath="NewFiling.Entity.Entity_Name"
      [options]="{ autoSearch: false, allowClear: true }"
      [criteria]="{ Role_Type: 'BK;BO;CL;CN;EM;FC;PR;RI;SP;TA;TP' }"
      (dataSelected)="entitySearchResult($event)"
    >
    </ep-field>
    <ep-field format="container" columnSpan="2">
      <aurora-button type="button" (click)="clearNewFilings()" variant="tertiary">Clear New Filings</aurora-button>
    </ep-field>
  </form>
</ep-sub-panel>
